import React from 'react';
import { Menu, MenuContent, MenuItem, MenuTrigger } from '../../../Menu/Menu';
import { ListItem } from '../../../List/ListItem';
import { Breadcrumb } from '../Breadcrumb/Breadcrumb';
import { BreadcrumbsItem } from '../../Breadcrumbs.types';

interface Props {
  items: BreadcrumbsItem[];
  onNavigate(item: BreadcrumbsItem, evt: Event): void;
}

export const OverflowMenu: React.FC<Props> = ({ items, onNavigate }) => {
  return (
    <Menu>
      <MenuTrigger>
        <Breadcrumb isActive={false}>...</Breadcrumb>
      </MenuTrigger>

      <MenuContent align="start">
        {items.map(item => (
          <MenuItem key={item.id} onSelect={evt => onNavigate(item, evt)}>
            <ListItem>{item.title}</ListItem>
          </MenuItem>
        ))}
      </MenuContent>
    </Menu>
  );
};
